import { render } from "./PolicyCard.vue?vue&type=template&id=32b3d792&scoped=true"
import script from "./PolicyCard.vue?vue&type=script&lang=js"
export * from "./PolicyCard.vue?vue&type=script&lang=js"

import "./PolicyCard.vue?vue&type=style&index=0&id=32b3d792&lang=scss&scoped=true"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32b3d792"]])

export default __exports__